import {Box, Text, Tooltip} from '@primer/react'

const DiffStatColor: Record<string, string> = {
  addition: 'diffstat.additionBg',
  deletion: 'danger.emphasis',
  neutral: 'neutral.bg',
}

const DiffStat = {
  addition: 'addition',
  deletion: 'deletion',
  neutral: 'neutral',
}

function buildToolTipLabel({
  linesAdded,
  linesChanged,
  linesDeleted,
}: {
  linesAdded: number
  linesChanged: number
  linesDeleted: number
}): string {
  let labelText = ''
  labelText += `${linesChanged} ${linesChanged === 1 ? 'change' : 'changes'}: `
  labelText += `${linesAdded} ${linesAdded === 1 ? 'addition' : 'additions'} & `
  labelText += `${linesDeleted} ${linesDeleted === 1 ? 'deletion' : 'deletions'}`
  return labelText
}

export default function DiffStats({
  linesAdded,
  linesDeleted,
  linesChanged,
}: {
  linesAdded: number
  linesDeleted: number
  linesChanged: number
}) {
  const totalSquares = 5
  let squares: string[] = [...Array<string>(5).fill(DiffStat.neutral)]

  if (linesChanged > 0) {
    let greenSquares = Math.floor((linesAdded / linesChanged) * totalSquares)
    linesAdded > 0 && (greenSquares = Math.max(1, greenSquares))
    let redSquares = Math.floor((linesDeleted / linesChanged) * totalSquares)
    linesDeleted > 0 && (redSquares = Math.max(1, redSquares))
    const graySquares = totalSquares - greenSquares - redSquares

    squares = [
      ...Array<string>(greenSquares).fill(DiffStat.addition),
      ...Array<string>(redSquares).fill(DiffStat.deletion),
      ...Array<string>(graySquares).fill(DiffStat.neutral),
    ]
  }

  return (
    <>
      <Text sx={{fontWeight: 'bold', fontSize: 0, color: 'success.fg', pl: 2}}>+{linesAdded}</Text>
      <Text sx={{fontWeight: 'bold', fontSize: 0, color: 'danger.fg', px: 1}}>-{linesDeleted}</Text>
      <Tooltip aria-label={buildToolTipLabel({linesAdded, linesChanged, linesDeleted})} direction="e">
        <DiffSquares squares={squares} />
      </Tooltip>
    </>
  )
}

export function DiffSquares({squares}: {squares: string[]}) {
  return (
    <Box sx={{display: 'flex'}}>
      {squares.map((diffStatType, i) => (
        <Box
          key={i}
          data-testid={`${diffStatType} diffstat`}
          sx={{
            backgroundColor: DiffStatColor[diffStatType],
            width: '8px',
            height: '8px',
            marginLeft: '1px',
            outlineOffset: '-1px',
            borderStyle: 'solid',
            borderColor: 'border.subtle',
            borderWidth: '1px',
          }}
        />
      ))}
    </Box>
  )
}

try{ DiffStats.displayName ||= 'DiffStats' } catch {}
try{ DiffSquares.displayName ||= 'DiffSquares' } catch {}